import { axiosErrorInterceptor } from '@miotech/esghub-web-lib-common';
import { Sentry, instance } from '@miotech/shared';
import { AxiosRequestConfig } from 'axios';
import QueryString from 'qs';

export interface IRequestError extends Error {
  code?: number;
  detailCode?: string;
}

interface IResponseBody<T> {
  code: number;
  message: string;
  detailCode: string;
  result: T;
}

instance.interceptors.request.use(config => {
  config.paramsSerializer = params =>
    QueryString.stringify(params, {
      encode: true,
    });
  return config;
});

instance.interceptors.response.use(
  response => {
    // 下载时文件流类型，不校验数据结构
    if (response.data && response.data instanceof Blob) {
      return Promise.resolve(response);
    }
    // 部分carbon的接口成功code是“200”
    if (response.data && response.data.code !== 0 && response.data.code !== '200') {
      // eslint-disable-next-line no-console
      console.error('接口数据异常:', response);
      Sentry.captureException(Error('接口数据异常:' + response.data.message));
      return Promise.reject(response.data);
    }
    return Promise.resolve(response);
  },
  error => {
    const errStr = String(error);
    // 接口 401 时都跳转登录页面
    if (errStr.indexOf('401') >= 0) {
      // 接受邀请页面为core内部页面特殊处理
      if (window.location.pathname === '/login') {
        return Promise.reject(error);
      }

      return Promise.reject(error);
    }
    if (axiosErrorInterceptor(error)) {
      // 当401时500ms后才跳转登录，因此接口响应也需要延时触发，否则会有用户信息获取不到导致报错
      return new Promise((_, reject) => {
        setTimeout(() => {
          reject(error);
        }, 600);
      });
    }
    return Promise.reject(error);
  },
);

export const connector = {
  get: async <T>(url: string, config?: AxiosRequestConfig<unknown>) => {
    return instance.get<IResponseBody<T>>(url, config).then(res => res.data.result);
  },
  post: async <T>(url: string, data?: unknown, config?: AxiosRequestConfig<unknown>) => {
    return instance.post<IResponseBody<T>>(url, data, config).then(res => res.data.result);
  },
  delete: async <T>(url: string, config?: AxiosRequestConfig<unknown>) => {
    return instance.delete<IResponseBody<T>>(url, config).then(res => res.data.result);
  },
};

export const setInterceptorsRequestHeaders = (userId: string) => {
  instance.interceptors.request.use(
    config => {
      config.headers = {
        ...(config.headers || {}),
        'X-User-Id': userId,
      };
      return config;
    },
    err => Promise.reject(err),
  );
};
